"use client";

import { c as _c } from "react/compiler-runtime";
import { IconDots, IconEdit, IconMessageReply, IconTrash } from "@tabler/icons-react";
import { useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Spinner } from "@/components/ui/spinner";
import { toast } from "@/components/ui/toast";
import { useSession } from "@/lib/auth-client";
import { type CommentWithUser, deleteComment } from "@/lib/server/comments";
import { EditCommentForm, ReplyForm } from "./comment-form";
type ActionMode = {
  type: "idle";
} | {
  type: "replying";
} | {
  type: "editing";
} | {
  type: "confirming-delete";
} | {
  type: "deleting";
};
const CommentActions = t0 => {
  const $ = _c(27);
  const {
    comment
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: "idle"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [mode, setMode] = useState(t1);
  const {
    data: session
  } = useSession();
  if (!session) {
    return null;
  }
  let t2;
  if ($[1] !== comment.id) {
    t2 = async () => {
      setMode({
        type: "deleting"
      });
      ;
      try {
        await deleteComment(comment.id);
        toast.add({
          title: "Your comment has been deleted successfully.",
          type: "success"
        });
        setMode({
          type: "idle"
        });
      } catch (t3) {
        const error = t3;
        console.error("Error deleting comment:", error);
        toast.add({
          title: "Failed to delete comment. Please try again.",
          type: "error"
        });
        setMode({
          type: "idle"
        });
      }
    };
    $[1] = comment.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleDelete = t2;
  const isDeleting = mode.type === "deleting";
  let t3;
  if ($[3] !== comment.content || $[4] !== comment.id || $[5] !== comment.pageSlug || $[6] !== comment.user || $[7] !== isDeleting || $[8] !== mode.type || $[9] !== session) {
    t3 = mode.type === "editing" ? <EditCommentForm slug={comment.pageSlug} commentId={comment.id} initialContent={comment.content} onCancel={() => setMode({
      type: "idle"
    })} onSuccess={() => setMode({
      type: "idle"
    })} /> : <div className="flex gap-2"><Button variant="outline" size="sm" onClick={() => setMode(mode.type === "replying" ? {
        type: "idle"
      } : {
        type: "replying"
      })}><IconMessageReply />Reply</Button>{session.user.id === comment.user.id && <DropdownMenu><DropdownMenuTrigger render={<Button variant="outline" size="sm" />}><IconDots /><span className="sr-only">Actions Menu</span></DropdownMenuTrigger><DropdownMenuContent><DropdownMenuItem onClick={() => setMode({
            type: "editing"
          })}><IconEdit />Edit</DropdownMenuItem><DropdownMenuItem onClick={() => setMode({
            type: "confirming-delete"
          })} disabled={isDeleting} variant="destructive">{isDeleting ? <Spinner /> : <IconTrash />}Delete</DropdownMenuItem></DropdownMenuContent></DropdownMenu>}</div>;
    $[3] = comment.content;
    $[4] = comment.id;
    $[5] = comment.pageSlug;
    $[6] = comment.user;
    $[7] = isDeleting;
    $[8] = mode.type;
    $[9] = session;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== comment.id || $[12] !== comment.pageSlug || $[13] !== mode.type) {
    t4 = mode.type === "replying" && <div className="mt-4"><ReplyForm slug={comment.pageSlug} parentId={comment.id} onCancel={() => setMode({
        type: "idle"
      })} onSuccess={() => setMode({
        type: "idle"
      })} /></div>;
    $[11] = comment.id;
    $[12] = comment.pageSlug;
    $[13] = mode.type;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const t5 = mode.type === "confirming-delete";
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = open => !open && setMode({
      type: "idle"
    });
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AlertDialogHeader><AlertDialogTitle>Delete comment?</AlertDialogTitle><AlertDialogDescription>This action cannot be undone.</AlertDialogDescription></AlertDialogHeader>;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <AlertDialogCancel>Cancel</AlertDialogCancel>;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== handleDelete) {
    t9 = <AlertDialogContent size="sm">{t7}<AlertDialogFooter>{t8}<AlertDialogAction variant="destructive" onClick={handleDelete}>Delete</AlertDialogAction></AlertDialogFooter></AlertDialogContent>;
    $[18] = handleDelete;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t5 || $[21] !== t9) {
    t10 = <AlertDialog open={t5} onOpenChange={t6}>{t9}</AlertDialog>;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t3 || $[25] !== t4) {
    t11 = <div className="mt-4">{t3}{t4}{t10}</div>;
    $[23] = t10;
    $[24] = t3;
    $[25] = t4;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export { CommentActions };